import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import sanitize from 'sanitize-html'
import { makeStyles } from 'beam'
import { Card, CardActions, CardContent } from 'beam/dist/Card'
import { Button } from 'beam/dist/Button'
import { NguiSnackbar } from '../../Common/NguiSnackbar'
import { setFedRAMPCompliance } from '../app.actions'
import { logout } from '../LegacyLogin/login.actions'
import logo from '../../Assets/calabrio_logo.png'
import { useFeatureAvailable } from '../../FeatureFlags'
import { RootState } from '../app.reducer'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${theme.spacing(6)}px)`,
  },
  pageFiller: {
    flex: '1 1 auto',
    paddingBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centeredBox: {
    boxSizing: 'border-box',
    padding: theme.spacing(2, 2),
    width: theme.spacing(100),
    marginBottom: theme.spacing(1),
  },
  messageContainer: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    maxHeight: '300px',
    overflowY: 'auto',
  },
  actions: {
    float: 'right',
  },
}))


const FedRAMPCompliance: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
  const complianceMessage: string = useFeatureAvailable('cher.fedramp-login-banner') as string // TODO: useFeatureAvailable() return type is `string | boolean`; remove this type coercion and update the code accordingly
  const classes = useStyles()
  const forgerockIdToken = useSelector((state: RootState) => state.app.forgerockIdToken)
  const frLoginUrl = useSelector((state: RootState) => state.app.frLoginUrl)
  const frOpUrl = useSelector((state: RootState) => state.app.frOpUrl)
  const frRealm = useSelector((state: RootState) => state.app.frRealm)
  const wasAuthFR = useSelector((state: RootState) => state.app.wasAuthFR)
  const handleAccept = async () => {
    try {
      await axios.put('/api/rest/user/compliance/fedramp')
      dispatch(setFedRAMPCompliance(true))
    } catch (e: $TSFIXME) {
      setErrorMessage(`${e.name}: ${e.message}`)
      setHasError(true)
    }
  }

  const handleDecline = () => {
    dispatch(logout(forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR))
  }

  return (
    <div className={classes.root}>
      <div className={classes.pageFiller}>
        <Card className={classes.centeredBox}>
          <CardContent>
            <img src={logo} alt="Logo" />
            <div className={classes.messageContainer} dangerouslySetInnerHTML={{ __html: sanitize(complianceMessage) }}></div>
          </CardContent>
          <CardActions className={classes.actions}>
            <Button color="default" onClick={handleDecline}>{t('Decline')}</Button>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={handleAccept}
            >{t('Accept')}</Button>
          </CardActions>
        </Card>
      </div>
      <NguiSnackbar
        open={hasError}
        variant="error"
        autoHideDuration={null}
        closeCallback={() => setHasError(false)}
        onClose={() => setHasError(false)}
        message={errorMessage}
      />
    </div>
  )
}

export default FedRAMPCompliance
